import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { ICreateReasonVisit } from "./interfaces/create-reason-for-visit.interface";
import { IUpdateReasonVisit } from "./interfaces/update-reason-for-visit.interface";
import { ReasonVisitAttributes } from "@albatrosdeveloper/ave-models-package";
import { AbstractService } from "app/services/abstract.service";
const apiUrl = env.API_UNIT_MEASURE;
const moduleName = "reason_visit";

@Injectable({
  providedIn: "root",
})
export class ReasonVisitService extends AbstractService<
  ReasonVisitAttributes,
  ICreateReasonVisit,
  IUpdateReasonVisit
> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<ReasonVisitAttributes>,
    companyIds: number[] // Add your companyIds if necessary
    ,
    statusIds: number[] // Add your statusIds if necessary
  ): Observable<IPaginationResult<ReasonVisitAttributes>> {
    const query = buildQuery<ReasonVisitAttributes>(
      where("_deleted", Ops.eq(false)),
      andWhere("id", Ops.like(options.search ?? "", "i")),
      orWhere("name", Ops.like(options.search ?? "", "i")),
      companyIds && companyIds.length > 0
        ? andAllWhere(
            "company.id" as keyof ReasonVisitAttributes,
            Ops.in(...companyIds)
          )
        : noop(),
        statusIds && statusIds.length > 0
        ? andAllWhere(
            "statusId" as keyof ReasonVisitAttributes,
            Ops.in(...statusIds)
          )
        : noop(),
      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<ReasonVisitAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(reason?: string[]): Observable<IRequestResult<ReasonVisitAttributes[]>> {
    const query = buildQuery<ReasonVisitAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      reason ? andWhere("name", Ops.in(...reason)) : noop(),
      select(["id", "name"]),
      orderBy("id", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<ReasonVisitAttributes[]>>(API_URL);
  }

  saveFileResonFile(file: File, optionLoad: string) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("transform", optionLoad);
    const API_URL: string = apiUrl + `api/${moduleName}/upload`;
    return this.http.post<IRequestResult<ReasonVisitAttributes>>(
      API_URL,
      formData
    );
  }

  getResonVistExcelData() {
    return env.REASONS_VISIT_DATA;
  }
}
